export default () => {
  window.addEventListener("scroll", function () {
    const body = document.body;
    const scrollY = window.scrollY || window.pageYOffset;
    if (scrollY > 100) {
      body.classList.add("is_scroll");
    } else {
      body.classList.remove("is_scroll");
    }
  });
}